import { render, staticRenderFns } from "./CancelOrderComponent.vue?vue&type=template&id=38c2491b&"
import script from "./CancelOrderComponent.vue?vue&type=script&lang=js&"
export * from "./CancelOrderComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports